import { useEffect } from "react";
import { useInput } from "hooks";
import { LabelledInput, LabelledSelect } from "../../../../Fields";
import { DecimalInput } from "components";
import { formatDollarValue } from "utils/dataUtils";

export const IncentiveCreditCard2TextBuilder = ({
  value = "",
  onChange = () => { },
}) => {
  const start = useInput("10.00");
  const end = useInput("");
  const type = useInput("$");
  const typeData = [
    { label: "$", value: "$", },
    { label: "%", value: "%" },
  ];

  const formatValue = (s, e, t) => {
    if (!s) return "";
    return t === "$"
      ? `$${formatDollarValue(s)}${e ? `-$${formatDollarValue(e)}` : ""}`
      : `${s}${t}${e ? `-${e}${t}` : ""}`;
  };

  const handleUpdateValue = (s, e, t) => {
    onChange(`Save ${formatValue(s, e, t)} w/store credit card`);
  };

  useEffect(() => {
    if (value.endsWith("w/store credit card") && value.startsWith("Save")) {
      let main = value.slice(0, -19).trim();
      main = main.slice(4).trim();
      if (main.startsWith("$")) {
        type.setValue("$");
        const parts = main.split("-");
        start.setValue(parts[0].replace("$", "").trim());
        end.setValue(parts[1] ? parts[1].replace("$", "").trim() : "");
      } else {
        type.setValue("%");
        const parts = main.split("-");
        start.setValue(parts[0].replace("%", "").trim());
        end.setValue(parts[1] ? parts[1].replace("%", "").trim() : "");
      }
    }
    return () => { };
  }, [value]);

  return (
    <div className="p-2 d-flex justify-content-between align-items-center">
      {type.value === "$" ? (
        <DecimalInput labeled label="Start Value" placeholder="Value" style={{ width: '90%' }}
          value={start.value}
          onChange={(e) => {
            start.setValue(e);
            handleUpdateValue(e, end.value, type.value);
          }}
        />
      ) : (
        <LabelledInput label="Start Value" placeholder="Value" style={{ width: '90%' }}
          allowclear="true" value={start.value}
          onChange={(e) => {
            start.setValue(e);
            handleUpdateValue(e, end.value, type.value);
          }}
        />
      )}

      <div className="mx-2">-</div>

      {type.value === "$" ? (
        <DecimalInput labeled label="End Value" placeholder="Value" style={{ width: '90%' }}
          value={end.value}
          onChange={(e) => {
            end.setValue(e);
            handleUpdateValue(start.value, e, type.value);
          }}
        />
      ) : (
        <LabelledInput label="End Value" placeholder="Value" style={{ width: '90%' }}
          allowclear="true" value={end.value}
          onChange={(e) => {
            end.setValue(e);
            handleUpdateValue(start.value, e, type.value);
          }}
        />
      )}

      <LabelledSelect label="Time" className="ml-2" options={typeData} value={type.value}
        onChange={(e) => {
          const nextStart = e === "$" ? formatDollarValue(start.value) : start.value;
          const nextEnd = e === "$" ? formatDollarValue(end.value) : end.value;
          type.setValue(e);
          start.setValue(nextStart);
          end.setValue(nextEnd);
          handleUpdateValue(nextStart, nextEnd, e);
        }} />
    </div>
  );
};